import React, { Component } from 'react'
import { connect } from 'react-redux';
let RealAdminView = null;

class AdminView extends Component {
  	constructor(props) {
    	super(props);
    	this.state = { isReady: RealAdminView !== null };
  	}

  	componentDidMount() {
  		const {isAuthenticated} = this.props
  		
  		if(!isAuthenticated) return
  		this.load()
  	}
  	
	componentWillReceiveProps({isAuthenticated}) {
		if(isAuthenticated && !RealAdminView) this.load()
	}

  	load() {
    	require.ensure('./admin', () => {
      		RealAdminView = require('./admin').RealAdminView;
      		if (!this.hasUnmounted) {
        		this.setState({ isReady: true });
      		}
    	});
  	}

  	componentWillUnmount() {
    	this.hasUnmounted = true;
  	}

  	render() {
  		return this.state.isReady ? <RealAdminView/> : null;
  	}
}

export default connect(state => ({isAuthenticated: state.auth.isAuthenticated}))(AdminView);



// WEBPACK FOOTER //
// ./src/fm/admin/AdminView.js